import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { NormalizedError } from '../../../constants/errorCodes';

interface ErrorState {
  current: NormalizedError | null;
}

const initialState: ErrorState = { current: null };

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    setError: (state, action: PayloadAction<NormalizedError>) => {
      state.current = action.payload;
    },
    clearError: (state) => {
      state.current = null;
    },
  },
});

export const { setError, clearError } = errorSlice.actions;
export default errorSlice.reducer;
